// extracted by mini-css-extract-plugin
export default {"Container":"TypesSection_Container__nXF1J"};